import React, { FC } from 'react';
import { Field } from 'redux-form';
import {
  LESSON_PRICE_CURRENCY,
  MAX_PRICE_PER_LESSON,
  MIN_PRICE_PER_LESSON,
  OfferFormFields,
} from 'src/pages-all/offer-form/offer-form.logic';
import { FormNumberInput } from 'components/form-inputs/form-number-input/form-number-input';
import { FieldWrapper } from 'components/teaching-inputs/common';

interface TeachingPriceInputProps {
  label: string;
}

export const TeachingPriceInput: FC<TeachingPriceInputProps> = ({ label }) => (
  <FieldWrapper>
    <Field
      name={OfferFormFields.price}
      component={FormNumberInput}
      style={{ width: '100%' }}
      min={MIN_PRICE_PER_LESSON}
      max={MAX_PRICE_PER_LESSON}
      precision={0}
      formatter={(value: string) => `${LESSON_PRICE_CURRENCY} ${value}`}
      label={label}
    />
  </FieldWrapper>
);
